<script setup lang="ts">
import {SvgIcon} from '../../../svg.ts';
</script>

<template>
  <div>
    <div class="tw:text-center tw:mt-16">
      <SvgIcon
        name="allspice-single-element-blue"
        :size="300"
        height="150"
        class="tw:text-secondary-dark-2"
      />
      <h2>No files selected... just yet!</h2>
      <span class="tw:text-text">Click one of the <span class="tw:font-semibold">files on the project panel to the left</span> to start your design review</span>
    </div>
  </div>
</template>
